export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    // const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png`;
    const newFileName = `/mayaicon.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        // const oldFileName = `/favicon-${favicon.sizes[[0]]}.png`;
        const oldFileName = `/mayaicon.png`;
        favicon.href = oldFileName;
      });
    }
  });
};
